import { Picker } from "@certn/cascadia-react";
import { format, subWeeks, subMonths, subYears } from "date-fns";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../hooks/useQueryParams";

/** API date filters expect ISO `yyyy-MM-dd`, not locale-dependent strings. */
export function toOrderTimeframeApiDate(date: Date): string {
  return format(date, "yyyy-MM-dd");
}

export function OrderTimeframeFilter({
  param,
  showExtendedOptions,
}: {
  param: string;
  showExtendedOptions?: boolean;
}) {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();
  const today = new Date();

  const filterOptions = [
    {
      id: toOrderTimeframeApiDate(today),
      name: t("Today"),
    },
    {
      id: toOrderTimeframeApiDate(subWeeks(today, 1)),
      name: t("Last 7 days"),
    },
    {
      id: toOrderTimeframeApiDate(subMonths(today, 1)),
      name: t("Last 30 days"),
    },
  ];

  if (showExtendedOptions) {
    filterOptions.push(
      {
        id: toOrderTimeframeApiDate(subMonths(today, 6)),
        name: t("Last 6 months"),
      },
      {
        id: toOrderTimeframeApiDate(subYears(today, 1)),
        name: t("Last year"),
      }
    );
  }

  return (
    <Picker
      showActionBar
      selectedKeys={params[param]?.split(",") || []}
      onSelectionChange={(keys) => setParam(param, Array.from(keys))}
      label={t("Order timeframe")}
      items={filterOptions}
      selectionMode="single"
      testID="order-timeframe-filter"
    />
  );
}
